/** https://www.w3schools.com/tags/ref_language_codes.asp */
export enum Language {
  EN = 'en',
  PL = 'pl',
}
export const DEFAULT_LANGUAGE = Language.EN
export const AVAILABLE_LANGUAGES = [Language.EN, Language.PL]
